const classes = Object.freeze({
    root: 'll-button ll-standard-button',
    disabled: 'll-button ll-standard-button ll-standard-button_disabled',
    label: 'll-standard-button__label'
});

export {
    classes,
};